import React, { useContext, useEffect, useState } from "react";
import { PulseLoader } from "react-spinners";
import Backbutton from "../../Components/Header/Backbutton";
import toast, { Toaster } from "react-hot-toast";
import Header from "../../Components/Header/Header";
import { AppContext } from "../../Context/AppContext";
import { Switch } from "antd";
import { useNavigate, useParams } from "react-router-dom";

function UpdateAdmin() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { adminsLoading, admins, updateAdminDetails, fetchAdmins } =
    useContext(AppContext);
  const [adminDetails, setAdminDetails] = useState({
    name: "",
    email: "",
    role: "",
    notifications: false,
  });
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!id || !admins || (admins && admins.length == 0)) return;

    const admin = admins.find((x) => x._id === id);

    setAdminDetails({
      name: admin.name,
      email: admin.email,
      notifications: admin.notifications,
      role: admin.role,
    });
  }, [admins]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "password" || name === "confirm_password") {
      const trimmedValue = value.replace(/\s+/g, "");
      setAdminDetails((prevDetails) => ({
        ...prevDetails,
        [name]: trimmedValue,
      }));
      return;
    }

    setAdminDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleEmptyFields = () => {
    if (
      !adminDetails.name ||
      adminDetails.name.trim() === "" ||
      adminDetails.name.length === 0 ||
      !adminDetails.email ||
      adminDetails.email.trim() === "" ||
      adminDetails.email.length === 0 ||
      !adminDetails.role
    ) {
      setError(true);
      return true;
    }
    setError(false);
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isEmpty = handleEmptyFields();
    if (isEmpty) {
      toast.error("Please fill all the fields.");
      return;
    }
    const payload = {
      id,
      ...adminDetails,
    };


    await updateAdminDetails(payload, {
      onSuccess: async () => {
        toast.success("Admin Details updated");
        await fetchAdmins();
        navigate("/admins");
      },
      onFailed: (error) => {
        const errMsg = error?.data ?? "Profile update failed!"
        toast.error(errMsg);
        console.error("Error updating admin details", error);
      },
    });
  };
  return (
    <>
      <Header />
      <div className="container-fluid background">
        <div className="mains">
          <Toaster position="top-center" />
          <div className="edit-title data mb-3">
            <div className="start-edit">
              <Backbutton />
            </div>
            <div className="center-edit text-center">
              <h4 className="dash-head text-center">Update Admin Profile</h4>
            </div>
          </div>
          <div className="section add-category">
            <div className="card review_card add_business_card">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
                    <div className="form-group">
                      <label htmlFor="name" className="form-label">
                        Fullname <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        id=""
                        className="form-control"
                        placeholder="Enter Admin Name"
                        onChange={handleChange}
                        value={adminDetails.name}
                      />
                      {error && adminDetails?.name.length === 0 && (
                        <span className="text-danger">Name is required</span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
                    <div className="form-group">
                      <label htmlFor="email" className="form-label">
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        id=""
                        className="form-control"
                        placeholder="Enter Admin Email Address"
                        onChange={handleChange}
                        value={adminDetails.email}
                        required
                      />
                      {error && adminDetails.email.length === 0 && (
                        <span className="text-danger">Email is required</span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
                    <div className="form-group">
                      <label htmlFor="email" className="form-label">
                        Role <span className="text-danger">*</span>
                      </label>
                      <select
                        name="role"
                        id=""
                        className="form-select"
                        onChange={handleChange}
                      >
                        <option
                          value="superadmin"
                          selected={adminDetails?.role === "superadmin"}
                        >
                          Super Admin
                        </option>
                        <option
                          value="admin"
                          selected={adminDetails?.role === "admin"}
                        >
                          Admin
                        </option>
                      </select>
                      {error && adminDetails.role.length === 0 && (
                        <span className="text-danger">Role is required</span>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
                    <div className="form-group">
                      <label htmlFor="email" className="form-label">
                        Notifications
                      </label>
                      <br />
                      <Switch
                        checked={adminDetails.notifications}
                        size="large"
                        onChange={(e) => {
                          setAdminDetails((prevDetails) => ({
                            ...prevDetails,
                            notifications: e,
                          }));
                        }}
                        disabled={
                          adminsLoading || adminDetails.role === "superadmin"
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="text-center mt-3">
                  <button
                    type="submit"
                    className="btn btn-danger"
                    disabled={adminsLoading}
                  >
                    {adminsLoading ? (
                      <PulseLoader color="#fff" size={10} />
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdateAdmin;
